import { UploadOutlined } from '@ant-design/icons';
import { Button, Col, FormInstance, Row, Typography } from 'antd';
import React from 'react';
import logo from '../img/logo.png';
import styles from '../index.css';
import { UploadWrapper } from './components/UploadWrapper';
import { CompWithFormProp } from './constants/constants';

export const FormHeader = React.memo(
  ({
    form,
    setCurrentStep,
    onValuesChange,
  }: CompWithFormProp & {
    setCurrentStep: (step: number) => void;
    onValuesChange: (changedValues: any, form: FormInstance) => void;
  }) => {
    return (
      <Row>
        <Col
          span={24}
          style={{
            textAlign: 'end',
            marginTop: 24,
          }}
        >
          <UploadWrapper
            form={form}
            setCurrentStep={setCurrentStep}
            onValuesChange={onValuesChange}
          >
            <Button icon={<UploadOutlined />}>Įkelti</Button>
          </UploadWrapper>
        </Col>
      </Row>
    );
  },
);
